export default "__VITE_ASSET__Ca6HAwPY__"